module.exports = __webpack_public_path__ + "static/img/fddxIcon.6f3c2444.png";